import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import React from 'react'
import TextAreaAutosize from 'react-textarea-autosize'

import widgetPreviewImage from './images/popup-box-preview.png'

const getWidgetScript = (companyKey) => `<script>
  (function(document) {
    var addWidgetScriptTag = function() {
      var lastScript = Array.prototype.slice.call(document.getElementsByTagName('script')).slice(-1)[0];
      var script = document.createElement('script');
      script.src = 'https://cdn.simplesat.io/js/widget/bottom.js';
      lastScript.parentNode.insertBefore(script, lastScript.nextSibling);
      script.addEventListener('load', function() {
        Widget.config({
          companyKey: '${companyKey}',
          theme: 'basic',
          showTestimonialDate: true,
          maxFeedback: '10'
        });
        Widget.render();
      });
    };
    document.addEventListener('DOMContentLoaded', addWidgetScriptTag);
  })(document);
</script>`

const onClickArea = (e) => {
  e.target.select()
}

export const PopupBox = ({ companyKey }) => {
  const scriptText = getWidgetScript(companyKey)
  return (
    <React.Fragment>
      <h3>Popup Box</h3>
      <p>
        The popup box sits fixed to the bottom left side of the browser window. This is a great
        option because it doesn't require you to find a specific location to insert a widget.
      </p>

      <p>
        <a
          href="https://help.simplesat.io/en/articles/843342-publishing-customer-feedback-and-ratings#create-a-feedback-widget"
          target="_blank"
          rel="noreferrer"
        >
          <i className="icon far fa-book" />
          Using the popup box testimonial widget
        </a>
      </p>

      <h4>Example Screenshot</h4>

      <img className="ui image" alt="feedback widget preview" src={widgetPreviewImage} />

      <hr style={{ marginTop: 0 }} />

      <h3>Code</h3>

      <p>Place this code on your website to load the popup widget script.</p>

      <div className="ui form">
        <div className="field">
          <TextAreaAutosize readOnly spellCheck="false" onClick={onClickArea} value={scriptText} />
        </div>
      </div>

      <h3>Settings</h3>

      <p>You can customize your widget's appearance by modifying the settings listed below. </p>

      <table className="ui celled striped table">
        <thead>
          <tr>
            <th>Setting</th>
            <th>Description</th>
            <th>Default</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <code>theme</code>
            </td>
            <td>
              Choose between <code>basic</code> and <code>blue</code> themes.
            </td>
            <td>
              <code>basic</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>showTestimonialDate</code>
            </td>
            <td>
              Option to display the date feedback was given. Set <code>true</code> to display,{' '}
              <code>false</code> to hide.
            </td>
            <td>
              <code>true</code>
            </td>
          </tr>
          <tr>
            <td>
              <code>maxFeedback</code>
            </td>
            <td>Choose the maximum number of feedback comments to display.</td>
            <td>
              <code>10</code>
            </td>
          </tr>
        </tbody>
      </table>

      <h3>Installation Instructions</h3>

      <h4>1. Add code to your website</h4>

      <p>
        Copy the entire snippet of code above and paste it in the <code>footer</code> section of
        your website.
      </p>

      <h4>2. Publish and test</h4>

      <p>
        On the <Link to="/feedback/">Feedback page</Link>, publish a testimonial by clicking the
        publish icon (<i className="far fa-bullhorn icon" />) next to any comment. After you publish,
        refresh the page where you've installed the feedback widget to ensure new testimonials are
        being updated properly.
      </p>
    </React.Fragment>
  )
}

PopupBox.propTypes = {
  companyKey: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/Admin/TestimonialsLegacy/PopupBox.js